const providerZipChecker = () => {
    const $$$ = document.querySelectorAll.bind(document);

    $$$('.provider-availability-form').forEach((i) => {
        i.addEventListener('submit', (e) => {
            e.preventDefault();
            const dataString = new FormData(e.target);

            const thisParentChecker = e.target.parentNode.parentNode.parentNode;
            thisParentChecker
                .querySelector('.zip-checker__results')
                .classList.add('hide');
            thisParentChecker
                .querySelector('.zip-checker__no')
                .classList.add('hide');
            thisParentChecker
                .querySelector('.zip-checker__yes')
                .classList.add('hide');
            e.target.querySelector('.button').classList.add('active');

            const zipToCheck = dataString.get('zip');
            const providerToCheck = dataString.get('provider');

            $.ajax({
                type: 'GET',
                dataType: 'json',
                url: '/wp/wp-admin/admin-ajax.php',
                data: `action=checkZipProvider&zip=${zipToCheck}&provider=${providerToCheck}`,
                success: (res) => {
                    if (res.result === 'no') {
                        // provider not available
                        thisParentChecker
                            .querySelector('.zip-checker__results')
                            .classList.remove('hide');
                        thisParentChecker
                            .querySelector('.zip-checker__no')
                            .classList.remove('hide');
                        thisParentChecker.querySelector(
                            '.zip-checker__see'
                        ).href = `/${res.state}/${res.city}?zip=${zipToCheck}`;
                    } else {
                        // provider is available
                        thisParentChecker
                            .querySelector('.zip-checker__results')
                            .classList.remove('hide');
                        thisParentChecker
                            .querySelector('.zip-checker__yes')
                            .classList.remove('hide');
                    }
                    e.target
                        .querySelector('.button')
                        .classList.remove('active');
                },
            });
        });
    });
};

export { providerZipChecker };
